/**
 * Grid of "panne" (breakdown) cards.
 * - `pannes` : array of { t, d } items.
 * - `title` : heading shown above the grid.
 * - `intro` (optional) : supporting paragraph.
 */
export default function PannesGrid({ pannes, title, intro }) {
    return (
        <section className="max-w-7xl mx-auto px-5 lg:px-10 py-14">
            <div className="divider-amber mb-5" />
            <h2 className="heading text-3xl lg:text-4xl font-extrabold">{title}</h2>
            {intro && <p className="mt-3 text-[var(--ink-soft)] max-w-2xl">{intro}</p>}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
                {pannes.map((p) => (
                    <article key={p.t} className="card-soft p-6">
                        <i className="fa-solid fa-screwdriver-wrench text-[var(--amber)] text-xl" />
                        <h3 className="heading text-lg font-bold mt-3">{p.t}</h3>
                        <p className="mt-2 text-sm text-[var(--ink-soft)]">{p.d}</p>
                    </article>
                ))}
            </div>
        </section>
    );
}
